import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";

import { ProjectEnvironmentsView } from "~/components/environments/ProjectEnvironmentsView";

function FocusedProjectEnvironmentsRoute() {
  const { projectId } = Route.useParams();
  return <ProjectEnvironmentsView fixedProjectId={ProjectId.makeUnsafe(projectId)} />;
}

export const Route = createFileRoute("/_chat/projects/$projectId/environments")({
  component: FocusedProjectEnvironmentsRoute,
});
